import DynamoDB from 'aws-sdk/clients/dynamodb'

export const lowercaseObjectValues = <T extends Object>(obj: T) =>
  Object.keys(obj).reduce((res, key) => {
    const val = obj[key]

    return {
      ...res,
      [key]: typeof val === 'string' ? val.toLowerCase() : val,
    }
  }, {} as T)

export const objectToUpdateItemAttributes = (obj: Record<string, any>) => {
  const keys = Object.keys(obj).filter((k) => Boolean(obj[k]))

  return {
    UpdateExpression: 'SET ' + keys.map((k) => `#${k} = :${k}`).join(', '),

    ExpressionAttributeNames: keys.reduce(
      (acc, cur) => ({ ...acc, [`#${cur}`]: cur }),
      {},
    ),

    ExpressionAttributeValues: keys.reduce(
      (acc, k) => ({ ...acc, [`:${k}`]: DynamoDB.Converter.marshall({ t: obj[k] }).t }),
      {},
    ),
  }
}
